class UserSystemRole {
  static get AGENT() {
    return { id: 1, Status: "AGENT" };
  }

  static get CLIENT() {
    return { id: 2, Status: "CLIENT" };
  }

  static get PROFILE() {
    return { id: 3, Status: "PROFILE" };
  }
  static get EMPLOYEE() {
    return { id: 4, Status: "EMPLOYEE" };
  }
  static get Types() {
    return [
      UserSystemRole.AGENT,
      UserSystemRole.CLIENT,
      UserSystemRole.PROFILE,
      UserSystemRole.EMPLOYEE,
    ];
  }
}

module.exports = UserSystemRole;
